export default "__VITE_ASSET__BVeqPyMt__"